/* WEST$HOP - interactive world map (jsvectormap) */
(function(){
'use strict';
  // i18n : textes injectés par la section (traduisibles via Translate & Adapt),
  // noms de pays localisés par le navigateur (Intl.DisplayNames) hors français.
  var I18N={};
  try{var i18nEl=document.getElementById('ws-map-i18n');if(i18nEl)I18N=JSON.parse(i18nEl.textContent);}catch(e){}
  var LANG=(document.documentElement.lang||'fr').split('-')[0];
  var DN=null;
  try{DN=new Intl.DisplayNames([LANG],{type:'region'});}catch(e){}
  function t(key,fallback){return I18N[key]||fallback;}
  function displayName(name){
    var entry=CATALOG[name];
    var code=entry&&entry.code;
    if(code&&LANG!=='fr'&&DN){
      if(code==='IL')code='PS';
      try{var n=DN.of(code);if(n)return n;}catch(e){}
    }
    return name;
  }
  // Regions data
  // Catalogue réel westshop.ca — 42 mini gants (vérifié sur /collections/all)
  const CATALOG={
    "Afghanistan":{code:"AF",url:"/products/afghanistan-mini-gants"},
    "Albanie":{code:"AL",url:"/products/albania-mini-gants"},
    "Bahamas":{code:"BS",url:"/products/bahamas-mini-gants",marker:[24.7,-78.0]},
    "Bangladesh":{code:"BD",url:"/products/bangladesh-mini-gants"},
    "Barbade":{code:"BB",url:"/products/barbados-mini-gants",marker:[13.19,-59.54]},
    "Burundi":{code:"BI",url:"/products/burundi-mini-gants",marker:[-3.37,29.92]},
    "Cambodge":{code:"KH",url:"/products/cambodge-mini-gants"},
    "Cameroun":{code:"CM",url:"/products/cameroon-mini-gants"},
    "Canada":{code:"CA",url:"/products/canada"},
    "Chili":{code:"CL",url:"/products/chili-mini-gants"},
    "Congo":{code:"CD",url:"/products/congo-mini-gants"},
    "Côte d'Ivoire":{code:"CI",url:"/products/cote-divoire-mini-gants"},
    "Égypte":{code:"EG",url:"/products/egypt-mini-gants"},
    "Salvador":{code:"SV",url:"/products/el-salvador-mini-gants",marker:[13.79,-88.90]},
    "Érythrée":{code:"ER",url:"/products/eritrea-mini-gants",marker:[15.18,39.78]},
    "Ghana":{code:"GH",url:"/products/ghana-mini-gants"},
    "Grenade":{code:"GD",url:"/products/grenada-gloves",marker:[12.11,-61.68]},
    "Guatemala":{code:"GT",url:"/products/guatamala-mini-gants"},
    "Guinée":{code:"GN",url:"/products/guinea-mini-gants"},
    "Guyane":{code:"GY",url:"/products/guyana-mini-gants",marker:[4.86,-58.93]},
    "Haïti":{code:"HT",url:"/products/haiti-mini-gants",marker:[18.97,-72.29]},
    "Honduras":{code:"HN",url:"/products/honduras-mini-gants"},
    "Inde":{code:"IN",url:"/products/india-mini-gants"},
    "Iran":{code:"IR",url:"/products/iran-mini-gants"},
    "Italie":{code:"IT",url:"/products/italie-mini-gants"},
    "Jamaïque":{code:"JM",url:"/products/jamaica-mini-gants",marker:[18.11,-77.30]},
    "Kabylie":{code:null,url:"/products/kabylie-mini-gants",marker:[36.7,4.5]},
    "Liban":{code:"LB",url:"/products/lebanon-mini-gants",marker:[33.87,35.86]},
    "Maroc":{code:"MA",url:"/products/morocco-mini-gants"},
    "Mexique":{code:"MX",url:"/products/mexico-mini-gants"},
    "Palestine":{code:"IL",url:"/products/palestine-mini-gants"},
    "Pérou":{code:"PE",url:"/products/peru-mini-gants"},
    "Portugal":{code:"PT",url:"/products/portugal"},
    "Porto Rico":{code:"PR",url:"/products/puerto-rico-mini-gants",marker:[18.22,-66.42]},
    "Québec":{code:null,url:"/products/quebec-mini-gants",marker:[52.0,-72.0]},
    "République dominicaine":{code:"DO",url:"/products/republic-dominican-mini-gants",marker:[18.74,-70.16]},
    "Saint-Vincent":{code:"VC",url:"/products/saint-vincent-mini-gants",marker:[13.25,-61.20]},
    "Sainte-Lucie":{code:"LC",url:"/products/saint-lucia",marker:[13.91,-60.98]},
    "Sri Lanka":{code:"LK",url:"/products/sri-lanka-mini-gants",marker:[7.87,80.77]},
    "Syrie":{code:"SY",url:"/products/syria-mini-gants"},
    "Trinidad":{code:"TT",url:"/products/trinidad-mini-gants",marker:[10.69,-61.22]},
    "Tunisie":{code:"TN",url:"/products/tunisia-mini-gants"}
  };
  const REGIONS={
    afrique:{name:"Afrique",pays:["Burundi","Cameroun","Congo","Côte d'Ivoire","Égypte","Érythrée","Ghana","Guinée","Kabylie","Maroc","Tunisie"]},
    europe:{name:"Europe",pays:["Albanie","Italie","Portugal"]},
    amlatine:{name:"Amérique latine",pays:["Chili","Guatemala","Guyane","Honduras","Mexique","Pérou","Salvador"]},
    caraibes:{name:"Caraïbes",pays:["Bahamas","Barbade","Grenade","Haïti","Jamaïque","Porto Rico","République dominicaine","Saint-Vincent","Sainte-Lucie","Trinidad"]},
    asie:{name:"Asie / Moyen-Orient",pays:["Afghanistan","Bangladesh","Cambodge","Inde","Iran","Liban","Palestine","Sri Lanka","Syrie"]},
    amnord:{name:"Amérique du Nord",pays:["Canada","Québec"]}
  };
  const nameEl=document.getElementById('region-name');
  const chipsEl=document.getElementById('region-chips');
  function setRegion(key){
    const r=REGIONS[key]; if(!r)return;
    nameEl.textContent=t('region_'+key,r.name);
    chipsEl.innerHTML=r.pays.map(p=>`<button type="button" class="ws-chip" data-pays="${p}">${displayName(p)}</button>`).join('');
    chipsEl.querySelectorAll('.ws-chip').forEach(b=>b.addEventListener('click',()=>selectByName(b.dataset.pays)));
    document.querySelectorAll('.region').forEach(el=>el.classList.toggle('active',el.dataset.region===key));
    document.querySelectorAll('.map-label').forEach(el=>el.classList.toggle('active',el.dataset.label===key));
    document.querySelectorAll('.ws-rbtn').forEach(el=>el.classList.toggle('active',el.dataset.region===key));
  }
  document.querySelectorAll('.region,.ws-rbtn').forEach(el=>{
    el.addEventListener('click',()=>setRegion(el.dataset.region));
  });
  setRegion('caraibes');

  // ---- Carte du monde interactive ----
  const FRNAME={AF:"Afghanistan",AL:"Albanie",BS:"Bahamas",BD:"Bangladesh",BB:"Barbade",BI:"Burundi",KH:"Cambodge",CM:"Cameroun",CA:"Canada",CL:"Chili",CD:"Congo",CG:"Congo-Brazzaville",CI:"Côte d'Ivoire",EG:"Égypte",SV:"Salvador",ER:"Érythrée",GH:"Ghana",GD:"Grenade",GT:"Guatemala",GN:"Guinée",GY:"Guyane",HT:"Haïti",HN:"Honduras",IN:"Inde",IR:"Iran",IT:"Italie",JM:"Jamaïque",LB:"Liban",MA:"Maroc",MX:"Mexique",IL:"Palestine",PE:"Pérou",PT:"Portugal",PR:"Porto Rico",DO:"République dominicaine",VC:"Saint-Vincent",LC:"Sainte-Lucie",LK:"Sri Lanka",SY:"Syrie",TT:"Trinidad",TN:"Tunisie",
    DZ:"Algérie",SN:"Sénégal",NG:"Nigéria",ET:"Éthiopie",ML:"Mali",FR:"France",ES:"Espagne",GR:"Grèce",TR:"Turquie",RS:"Serbie",HR:"Croatie",DE:"Allemagne",BE:"Belgique",BR:"Brésil",CO:"Colombie",AR:"Argentine",EC:"Équateur",CU:"Cuba",VN:"Vietnam",PH:"Philippines",PK:"Pakistan",CN:"Chine",JP:"Japon",US:"États-Unis",AU:"Australie",NZ:"Nouvelle-Zélande",GB:"Royaume-Uni",RU:"Russie",MZ:"Mozambique",AO:"Angola",KE:"Kenya",ZA:"Afrique du Sud"};
  const NAME2ISO={};Object.entries(FRNAME).forEach(([c,n])=>{if(!(n in NAME2ISO))NAME2ISO[n]=c;});
  const ISO2REGION={};
  Object.entries(REGIONS).forEach(([reg,r])=>r.pays.forEach(n=>{const c=(CATALOG[n]||{}).code;if(c)ISO2REGION[c]=reg;}));

  const selName=document.getElementById('selected-country');
  const selLink=document.getElementById('selected-link');
  let worldMap=null;

  function countryName(code){
    if(LANG!=='fr'&&DN){
      var c=code==='IL'?'PS':code;
      try{var n=DN.of(c);if(n&&n!==c)return n;}catch(e){}
    }
    if(FRNAME[code])return FRNAME[code];
    try{return worldMap.regions[code].config.name;}catch(e){return code;}
  }
  function regionOfName(name){for(const k in REGIONS){if(REGIONS[k].pays.includes(name))return k;}return null;}

  // Drapeaux sans code ISO (introuvables sur flagcdn) — intégrés en data-URI
  const CUSTOM_FLAGS={
    "Kabylie":"data:image/png;base64,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",
    "Québec":"data:image/png;base64,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"
  };
  function applySelection(name,code){
    selName.textContent=displayName(name);
    const entry=CATALOG[name];
    if(entry){
      selLink.href=entry.url;
      selLink.textContent=t('view_glove','Voir le gant')+' '+displayName(name)+' \u2192';
    }else{
      selLink.href='/collections/all';
      selLink.textContent=displayName(name)+' \u00b7 '+t('not_available','pas encore disponible \u2014 voir la collection')+' \u2192';
    }
    selLink.style.display='inline-block';
    const reg=(code&&ISO2REGION[code])||regionOfName(name);
    if(reg)setRegion(reg);
    document.querySelectorAll('#region-chips .ws-chip').forEach(ch=>{
      ch.classList.toggle('sel',ch.dataset.pays===name);
    });
    const flag=document.getElementById('selected-flag');
    if(flag){
      if(CUSTOM_FLAGS[name]){
        flag.src=CUSTOM_FLAGS[name];
        flag.removeAttribute('srcset');
        flag.alt='Drapeau '+name;
        flag.style.display='inline-block';
        flag.onerror=function(){this.style.display='none';};
      }else if(code){

        if (code.toLowerCase() === 'il') {
            code = 'PS';
            name = 'Palestine';
        }

        flag.src='https://flagcdn.com/w40/'+code.toLowerCase()+'.png';
        flag.srcset='https://flagcdn.com/w80/'+code.toLowerCase()+'.png 2x';
        flag.alt='Drapeau '+name;
        flag.style.display='inline-block';
        flag.onerror=function(){this.style.display='none';};
      }else{
        flag.style.display='none';
      }
    }
  }
  function clearMarkerSelection(){
    if(!worldMap)return;
    try{worldMap.clearSelectedMarkers();}catch(e){}
  }
  function highlightOnMap(code){
    if(!worldMap)return;
    try{worldMap.clearSelectedRegions();}catch(e){}
    if(!code)return;
    try{worldMap.setSelectedRegions([code]);}
    catch(e){try{worldMap.regions[code].element.select(true);}catch(_){}}
  }
  function highlightMarkerByName(name){
    if(!worldMap||!worldMap._wsMarkers)return;
    const idx=worldMap._wsMarkers.findIndex(m=>m.name===name);
    if(idx<0)return;
    try{worldMap.setSelectedMarkers([idx]);}catch(e){}
  }
  function selectCountry(code){applySelection(countryName(code),code);}

  // Sélection depuis les pastilles du bas : remonte à la carte + zoom léger
  function selectByName(name){
    const entry=CATALOG[name]||{};
    const code=entry.code||NAME2ISO[name]||null;
    applySelection(name,code);
    clearMarkerSelection();
    highlightOnMap(code);
    if(entry.marker)highlightMarkerByName(name);
    const holder=document.getElementById('worldmap');
    if(holder)holder.scrollIntoView({behavior:'smooth',block:'center'});
    if(worldMap){
      try{
        if(entry.marker){worldMap.setFocus({coords:entry.marker,scale:4,animate:true});}
        else if(code){worldMap.setFocus({region:code,animate:true});}
      }catch(e){}
    }
  }

  function initWorldMap(){
    const holder=document.getElementById('worldmap');
    if(!window.jsVectorMap){
      holder.innerHTML='<p style="color:var(--grey);text-align:center;padding:40px 20px">Carte interactive indisponible hors connexion \u2014 utilisez les boutons de r\u00e9gion ci-dessous.</p>';
      return;
    }
    // Marqueurs dorés : petits pays du catalogue toujours visibles et cliquables (Liban, Haïti, îles…)
    const MARKERS=Object.entries(CATALOG).filter(([n,e])=>e.marker).map(([n,e])=>({name:n,coords:e.marker}));
    // Pays disponibles à l'achat (codes du CATALOG, inchangés) → teinte "Gant disponible" de la légende
    const AVAIL_VALUES={};
    Object.values(CATALOG).forEach(e=>{if(e.code)AVAIL_VALUES[e.code]='avail';});
    worldMap=new jsVectorMap({
      selector:'#worldmap',
      map:'world',
      backgroundColor:'transparent',
      zoomButtons:true,
      zoomOnScroll:false,
      zoomAnimate:true,
      zoomMax:12,
      zoomMin:1,
      bindTouchEvents:true,
      regionsSelectable:true,
      regionsSelectableOne:true,
      regionStyle:{
        initial:{fill:'#2a2d3a',stroke:'#0e0f14',strokeWidth:.6},
        hover:{fill:'#f5c343',cursor:'pointer'},
        selected:{fill:'#e8352c'}
      },
      series:{
        regions:[{
          attribute:'fill',
          scale:{avail:'#f0a35c'},
          values:AVAIL_VALUES
        }]
      },
      markers:MARKERS,
      markerStyle:{
        initial:{r:9,fill:'#f5c343',stroke:'#0e0f14',strokeWidth:2.5,fillOpacity:1},
        hover:{r:13,fill:'#e8352c',stroke:'#f7f6f2',strokeWidth:2.5,cursor:'pointer'},
        selected:{r:11,fill:'#e8352c',stroke:'#f7f6f2',strokeWidth:2.5}
      },
      markersSelectable:true,
      markersSelectableOne:true,
      onRegionClick:function(event,code){clearMarkerSelection();selectCountry(code);},
      onMarkerClick:function(event,index){
        const mk=MARKERS[index];
        if(!mk)return;
        const entry=CATALOG[mk.name]||{};
        clearMarkerSelection();
        applySelection(mk.name,entry.code||null);
        highlightOnMap(entry.code||null);
      },
      onRegionTooltipShow:function(event,tooltip,code){
        try{tooltip.text(countryName(code));}catch(e){}
      },
      onMarkerTooltipShow:function(event,tooltip,index){
        try{tooltip.text(displayName(MARKERS[index].name));}catch(e){}
      }
    });
    worldMap._wsMarkers=MARKERS;
  }
  function ensureWorldMap(){
    var holder=document.getElementById('worldmap');
    if(!holder)return;
    var tries=0;
    // La carte ne doit s'initialiser qu'une fois le conteneur réellement dimensionné,
    // sinon jsvectormap fige des positions NaN impossibles à corriger ensuite.
    (function attempt(){
      var r=holder.getBoundingClientRect();
      if((r.width<50||r.height<50)&&tries<50){tries++;setTimeout(attempt,100);return;}
      initWorldMap();
      setTimeout(function(){
        var c=document.querySelector('#worldmap circle');
        if(c&&isNaN(parseFloat(c.getAttribute('cx')))){
          holder.innerHTML='';
          worldMap=null;
          initWorldMap();
        }
      },400);
    })();
  }
  if(document.readyState==='complete'){ensureWorldMap();}
  else{window.addEventListener('load',ensureWorldMap);}
  // Redimensionnement : recalcule la taille de la carte quand le viewport change
  let resizeTimer=null;
  function refreshMapSize(){
    if(!worldMap)return;
    try{worldMap.updateSize();}catch(e){}
  }
  window.addEventListener('resize',()=>{
    clearTimeout(resizeTimer);
    resizeTimer=setTimeout(refreshMapSize,150);
  });
  window.addEventListener('orientationchange',()=>setTimeout(refreshMapSize,300));
  // Certains navigateurs mobiles ne déclenchent pas resize au chargement complet
  window.addEventListener('load',refreshMapSize);
})();
